// src/auth/RequireLeagueAdmin.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RequireLeagueAdmin = ({ children }) => {
  const { user } = useAuth();

  if (!user || (user.role !== 2 && user.role !== 3)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireLeagueAdmin;
